export class Evaluation {
    id?: any;
    providerNumber?: any;
    evaluationNumber?: any;
    surveyType?: any;
    department?: any;
    district?: any;
    initialIndicator?: any;
    medicare?: any;
    insertUid?: any;
    insertDate?: any;
    aspenEvent?: any;
    tierPriority?: any;
    chowIndicator?: any;
    jiraIssueKey?: any;
    evaluationType?: any;
    evaluationSubType?: any;
    providerName?: any;
    providerCounty?: any;
    providerType?: any;
    fiscalYear?: any;
    modifyUid?: any;
    modifyDate?: any;
    jobName?: any;
    endDate?:  Date | null = null;
    status?: any;
    startDate?: Date | null = null;
    dueDate?:  Date | null = null;
    revisitNumber?: any;
    teamLead?: any;
    scheduleStart?:  Date | null = null;
    scheduleEnd?:  Date | null = null;
    hfid?: any;
    providerGroup?: any;
    openGovId?: any;
    emailAddr?: any;
    fedId?: any;
    licName?: any;
    licNbr?: any;
    city?: any;
}